import { BroadcastStatus, UgcLiveStatus } from '@yandex-360/telemost-sdk';

export const UGC_LIVE_STATUS_TO_BROADCAST_STATUS: Partial<Record<UgcLiveStatus, BroadcastStatus>> = {
    created: BroadcastStatus.CREATED,
    onair: BroadcastStatus.STARTED,
    finished: BroadcastStatus.FINISHED,
};
